import './buildings.css';
import classNames from 'classnames';

function MobileBuildings({ isDay }) {
  return (
    <svg 
      className="mobile-buildings-svg" 
      viewBox="0 0 1466 1535" 
      preserveAspectRatio="xMidYMax meet"
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M663.123 1209.1V1238.19" stroke="black"/>
      <path d="M747.457 929.179V1330.8V1525.92H463.132V675.671H549.445V755.426H617.988V832.333H689.069V929.179H747.457Z" className={classNames("tetris-building", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="690.128" y="976.829" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="690.128" y="1038.25" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="690.128" y="1096.45" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="690.128" y="1219.29" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="690.128" y="1342.14" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="690.128" y="1403.57" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="690.128" y="1157.87" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="690.128" y="1280.72" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="690.128" y="1403.57" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="690.128" y="1464.99" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="492.546" y="853.979" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="492.546" y="915.404" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="492.546" y="976.829" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="492.546" y="1038.25" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="492.546" y="1096.45" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="492.546" y="1157.87" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="492.546" y="1219.29" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="492.546" y="1342.14" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="492.546" y="1403.57" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="492.546" y="1280.72" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="492.546" y="1403.57" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="492.546" y="1464.99" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="560.013" y="789.322" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="492.546" y="789.322" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="560.013" y="853.979" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="560.013" y="915.404" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="560.013" y="976.829" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="560.013" y="1038.25" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="560.013" y="1096.45" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="560.013" y="1219.29" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="560.013" y="1342.14" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="560.013" y="1403.57" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="560.013" y="1157.87" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="560.013" y="1280.72" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="560.013" y="1403.57" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="560.013" y="1464.99" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="627.48" y="853.979" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="627.48" y="915.404" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="627.48" y="976.829" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="627.48" y="1038.25" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="627.48" y="1096.45" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="627.48" y="1219.29" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="627.48" y="1342.14" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="627.48" y="1403.57" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="627.48" y="1157.87" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="627.48" y="1280.72" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="627.48" y="1403.57" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="627.48" y="1464.99" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="492.546" y="705.267" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M1046.24 1525.92V641.283H1106.83V462.214H1138.33V371.914H1172.26V344.365H1201.34V165.295L1259.51 119.38L1315.25 165.295V344.365H1346.75V371.914H1383.1V462.214H1414.61V641.283H1465.5V1525.92H1324.94H1189.22H1046.24Z" className={classNames("empire-state-building", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M1189.22 641.283V1525.92M1189.22 641.283H1106.83M1189.22 641.283V462.214H1138.33M1189.22 1525.92H1046.24V641.283H1106.83M1189.22 1525.92H1324.94M1106.83 641.283V462.214H1138.33M1138.33 462.214V371.914H1172.26M1324.94 1525.92V641.283M1324.94 1525.92H1465.5V641.283H1414.61M1324.94 641.283V462.214H1383.1M1324.94 641.283H1414.61M1414.61 641.283V462.214H1383.1M1383.1 462.214V371.914H1346.75M1346.75 371.914V344.365H1315.25M1346.75 371.914H1172.26M1172.26 371.914V344.365H1201.34M1201.34 344.365V165.295M1201.34 344.365H1315.25M1201.34 165.295H1315.25M1201.34 165.295L1259.51 119.38M1315.25 165.295V344.365M1315.25 165.295L1259.51 119.38M1259.51 119.38V0" stroke="black"/>
      <rect x="1162.4" y="398.144" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1215.41" y="453.103" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1268.42" y="453.103" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1268.42" y="508.062" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1268.42" y="563.02" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1268.42" y="617.979" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1268.42" y="672.938" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1268.42" y="727.897" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1268.42" y="782.856" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1268.42" y="837.815" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1268.42" y="892.774" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1268.42" y="947.733" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1268.42" y="1002.69" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1268.42" y="1057.65" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1268.42" y="1112.61" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1268.42" y="1167.57" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1268.42" y="1222.53" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1268.42" y="1277.49" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1268.42" y="1332.45" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1268.42" y="1387.4" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1268.42" y="1442.36" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1215.41" y="1442.36" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1215.41" y="1387.4" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1215.41" y="1332.45" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1215.41" y="1277.49" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1215.41" y="1222.53" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1215.41" y="1167.57" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1215.41" y="1112.61" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1215.41" y="1057.65" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1215.41" y="1002.69" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1215.41" y="947.733" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1215.41" y="892.774" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1215.41" y="837.815" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1215.41" y="782.856" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1215.41" y="727.897" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1215.41" y="672.938" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1215.41" y="617.979" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1215.41" y="563.02" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1215.41" y="508.062" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1215.41" y="398.144" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1268.42" y="398.144" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1321.43" y="398.144" width="32.7336" height="34.5616" fill="black" stroke="black"/>
      <rect x="1355.16" y="508.062" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1128.66" y="508.062" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1128.66" y="563.02" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1128.66" y="672.938" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1355.16" y="672.938" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1355.16" y="727.897" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1355.16" y="782.856" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1355.16" y="837.815" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1355.16" y="892.774" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1355.16" y="947.733" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1355.16" y="1002.69" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1355.16" y="1057.65" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1355.16" y="1112.61" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1355.16" y="1167.57" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1355.16" y="1222.53" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1355.16" y="1277.49" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1355.16" y="1332.45" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1355.16" y="1387.4" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1355.16" y="1442.36" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1408.17" y="672.938" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1408.17" y="727.897" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1408.17" y="782.856" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1408.17" y="837.815" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1408.17" y="892.774" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1408.17" y="947.733" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1408.17" y="1002.69" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1408.17" y="1057.65" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1408.17" y="1112.61" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1408.17" y="1167.57" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1408.17" y="1222.53" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1408.17" y="1277.49" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1408.17" y="1332.45" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1408.17" y="1387.4" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1408.17" y="1442.36" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1128.66" y="727.897" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1128.66" y="782.856" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1128.66" y="837.815" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1128.66" y="892.774" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1128.66" y="947.733" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1128.66" y="1002.69" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1128.66" y="1057.65" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1128.66" y="1112.61" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1128.66" y="1167.57" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1128.66" y="1222.53" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1128.66" y="1277.49" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1128.66" y="1332.45" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1128.66" y="1387.4" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1128.66" y="1442.36" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1066.02" y="1442.36" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1066.02" y="672.938" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1066.02" y="727.897" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1066.02" y="782.856" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1066.02" y="837.815" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1066.02" y="892.774" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1066.02" y="947.733" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1066.02" y="1002.69" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1066.02" y="1057.65" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1066.02" y="1112.61" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1066.02" y="1167.57" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1066.02" y="1222.53" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1066.02" y="1277.49" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1066.02" y="1332.45" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <rect x="1066.02" y="1387.4" width="32.7336" height="34.5616" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M1390.3 563.02V597.582H1357.57V563.02H1390.3Z" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M460.722 877.726H0.5V900.356H460.722V877.726Z" stroke="black"/>
      <path d="M460.722 900.356H0.5V922.986H460.722V900.356Z" stroke="black"/>
      <path d="M460.722 922.986H0.5V945.616H460.722V922.986Z" stroke="black"/>
      <path d="M460.722 855.096H0.5V877.726H460.722V855.096Z" stroke="black"/>
      <path d="M460.722 840.548H0.5V893.89V1525.92H460.722V840.548Z" className={classNames("midsized-grey-building", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M460.722 1330.33H0.5V1352.96H460.722V1330.33Z" stroke="black"/>
      <path d="M460.722 1126.66H0.5V1149.29H460.722V1126.66Z" stroke="black"/>
      <path d="M460.722 922.986H0.5V945.616H460.722V922.986Z" className={classNames("midsized-grey-building-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M460.722 945.616H0.5V968.246H460.722V945.616Z" stroke="black"/>
      <path d="M460.722 968.247H0.5V990.877H460.722V968.247Z" className={classNames("midsized-grey-building-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M460.722 990.877H0.5V1013.51H460.722V990.877Z" stroke="black"/>
      <path d="M460.722 1013.51H0.5V1036.14H460.722V1013.51Z" className={classNames("midsized-grey-building-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M460.722 1036.14H0.5V1058.77H460.722V1036.14Z" stroke="black"/>
      <path d="M460.722 1058.77H0.5V1081.4H460.722V1058.77Z" className={classNames("midsized-grey-building-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M460.722 1081.4H0.5V1104.03H460.722V1081.4Z" stroke="black"/>
      <path d="M460.722 1104.03H0.5V1126.66H460.722V1104.03Z" className={classNames("midsized-grey-building-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M460.722 1330.33H0.5V1352.96H460.722V1330.33Z" className={classNames("midsized-grey-building-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M460.722 1375.59H0.5V1398.22H460.722V1375.59Z" className={classNames("midsized-grey-building-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M460.722 1398.22H0.5V1420.85H460.722V1398.22Z" stroke="black"/>
      <path d="M460.722 1420.85H0.5V1443.48H460.722V1420.85Z" className={classNames("midsized-grey-building-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M460.722 1443.48H0.5V1466.11H460.722V1443.48Z" stroke="black"/>
      <path d="M460.722 1466.11H0.5V1488.74H460.722V1466.11Z" className={classNames("midsized-grey-building-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M460.722 1149.29H0.5V1171.92H460.722V1149.29Z" className={classNames("midsized-grey-building-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M460.722 1171.92H0.5V1194.55H460.722V1171.92Z" stroke="black"/>
      <path d="M460.722 1194.55H0.5V1217.18H460.722V1194.55Z" className={classNames("midsized-grey-building-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M460.722 1217.18H0.5V1239.81H460.722V1217.18Z" stroke="black"/>
      <path d="M460.722 1239.81H0.5V1262.44H460.722V1239.81Z" className={classNames("midsized-grey-building-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M460.722 1262.44H0.5V1285.07H460.722V1262.44Z" stroke="black"/>
      <path d="M460.722 1285.07H0.5V1307.7H460.722V1285.07Z" className={classNames("midsized-grey-building-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M460.722 1307.7H0.5V1330.33H460.722V1307.7Z" stroke="black"/>
      <path d="M460.722 1307.7H0.5V1330.33H460.722V1307.7Z" stroke="black"/>
      <path d="M1012.51 539.891L752.276 695.069V1534H1041.42V539.891H1012.51Z" className={classNames("polygon-building", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M1041.42 740.329H752.276V759.726H1041.42V740.329Z" stroke="black"/>
      <path d="M752.276 740.329V724.164H1041.42V740.329H752.276Z" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M1041.42 759.726H752.276V779.123H1041.42V759.726Z" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M1041.42 817.918H752.276V837.315H1041.42V817.918Z" stroke="black"/>
      <path d="M1041.42 837.315H752.276V856.712H1041.42V837.315Z" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M1041.42 856.712H752.276V876.11H1041.42V856.712Z" stroke="black"/>
      <path d="M1041.42 876.109H752.276V895.507H1041.42V876.109Z" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M1041.42 914.904H752.276V934.301H1041.42V914.904Z" stroke="black"/>
      <path d="M1041.42 934.301H752.276V953.699H1041.42V934.301Z" stroke="black"/>
      <path d="M1041.42 953.698H752.276V973.096H1041.42V953.698Z" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M752.276 895.507H1041.42M752.276 895.507C865.194 895.507 928.503 895.507 1041.42 895.507V914.904H752.276V895.507Z" stroke="black"/>
      <path d="M1041.42 914.904H752.276V934.301H1041.42V914.904Z" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M752.276 914.904H1041.42M752.276 914.904C865.194 914.904 928.503 914.904 1041.42 914.904V934.301H752.276V914.904Z" stroke="black"/>
      <path d="M1041.42 973.096H752.276V992.493H1041.42V973.096Z" stroke="black"/>
      <path d="M1041.42 992.493H752.276V1011.89H1041.42V992.493Z" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M1041.42 1011.89H752.276V1031.29H1041.42V1011.89Z" stroke="black"/>
      <path d="M1041.42 1031.29H752.276V1050.68H1041.42V1031.29Z" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M1041.42 1050.68H752.276V1070.08H1041.42V1050.68Z" stroke="black"/>
      <path d="M1041.42 1070.08H752.276V1089.48H1041.42V1070.08Z" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M1041.42 1089.48H752.276V1108.88H1041.42V1089.48Z" stroke="black"/>
      <path d="M1041.42 1108.88H752.276V1128.27H1041.42V1108.88Z" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M1041.42 1128.27H752.276V1147.67H1041.42V1128.27Z" stroke="black"/>
      <path d="M1041.42 779.123H752.276V798.521H1041.42V779.123Z" stroke="black"/>
      <path d="M1041.42 798.521H752.276V817.918H1041.42V798.521Z" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M1041.42 1147.67H752.276V1167.07H1041.42V1147.67Z" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M1041.42 1167.07H752.276V1186.47H1041.42V1167.07Z" stroke="black"/>
      <path d="M1041.42 1225.26H752.276V1244.66H1041.42V1225.26Z" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M1041.42 1186.47H752.276V1205.86H1041.42V1186.47Z" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M1041.42 1264.05H752.276V1283.45H1041.42V1264.05Z" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M1041.42 1283.45H752.276V1302.85H1041.42V1283.45Z" stroke="black"/>
      <path d="M1041.42 1302.85H752.276V1322.25H1041.42V1302.85Z" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M1041.42 1322.25H752.276V1341.64H1041.42V1322.25Z" stroke="black"/>
      <path d="M1041.42 1341.64H752.276V1361.04H1041.42V1341.64Z" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M1041.42 1361.04H752.276V1380.44H1041.42V1361.04Z" stroke="black"/>
      <path d="M1041.42 1380.44H752.276V1399.84H1041.42V1380.44Z" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M1041.42 1399.84H752.276V1419.23H1041.42V1399.84Z" stroke="black"/>
      <path d="M1041.42 1419.23H752.276V1438.63H1041.42V1419.23Z" stroke="black"/>
      <path d="M1041.42 1419.23H752.276V1438.63H1041.42V1419.23Z" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M1041.42 1438.63H752.276V1458.03H1041.42V1438.63Z" stroke="black"/>
      <path d="M1041.42 1458.03H752.276V1477.42H1041.42V1458.03Z" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
      <path d="M1041.42 1477.42H752.276V1496.82H1041.42V1477.42Z" stroke="black"/>
      <path d="M1041.42 1496.82H752.276V1516.22H1041.42V1496.82Z" className={classNames("black-yellow-windows", {
        "night": !isDay
      })} stroke="black"/>
    </svg>
  );
}

export default MobileBuildings;

